{
  "version": 1,
  "asset_id": "6d597c3e-7ec0-42ee-8125-5ddf726c47f4",
  "project_id": "8f4e0cb3-546d-4528-9687-8899f14664d6",
  "url": "/__l5e/assets-v1/6d597c3e-7ec0-42ee-8125-5ddf726c47f4/ia-barbers-roldan.png",
  "r2_key": "a/v1/8f4e0cb3-546d-4528-9687-8899f14664d6/6d597c3e-7ec0-42ee-8125-5ddf726c47f4/ia-barbers-roldan.png",
  "original_filename": "ia-barbers-roldan.png",
  "size": 368650,
  "content_type": "image/png",
  "created_at": "2026-11-05T15:14:39Z"
}
